const loaded = new Map<string, Promise<void>>();

export function loadScript(url: string): Promise<void> {
  const cached = loaded.get(url);
  if (cached) return cached;

  const promise = new Promise<void>((resolve, reject) => {
    const script = document.createElement("script");
    script.src = `${url}?v=${Date.now()}`;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Failed to load MFE: ${url}`));
    document.head.appendChild(script);
  });

  loaded.set(url, promise);
  return promise;
}
